import { type AssetType, type Stored } from "@overmap-ai/common"
import { selectAssetTypes } from "@overmap-ai/core"
import { ReactRenderer } from "@tiptap/react"

import { appStore } from "../../../../store"
import type { MentionListRef, MentionListRootProps } from "../../../blocks"
import { AssetTypeMentionList } from "../../../components"
import type { SuggestionOptions } from "../typings"
import { updatePosition } from "../utils"

export const suggestion: SuggestionOptions<Stored<AssetType>> = {
	char: "@at",
	items: ({ query }) => {
		const assetTypes = selectAssetTypes(appStore.getState())

		return assetTypes
			.filter((assetType) => assetType.name.toLowerCase().startsWith(query.toLowerCase()))
			.slice(0, 10)
	},

	render: () => {
		let component: ReactRenderer<MentionListRef<Stored<AssetType>>, MentionListRootProps<Stored<AssetType>>>

		return {
			onStart: (props) => {
				component = new ReactRenderer(AssetTypeMentionList, {
					props,
					editor: props.editor,
					as: "div",
				})

				if (!props.clientRect) {
					return
				}

				;(component.element as HTMLElement).style.position = "fixed"
				component.element.setAttribute("data-floating-content", "")

				document.body.appendChild(component.element)

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onUpdate(props) {
				component.updateProps(props)

				if (!props.clientRect) {
					return
				}

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onKeyDown(props) {
				if (props.event.key === "Escape") {
					component.destroy()

					return true
				}

				return component.ref?.onKeyDown?.(props) ?? false
			},

			onExit() {
				component.element.remove()
				component.destroy()
			},
		}
	},
}
